document.addEventListener("DOMContentLoaded", function () {
  if (!window.location.pathname.match(/^\/cart\/?$/)) return;

  // 1. Add all your collection handles here
  const allCollections = [
    "sale"
  ];
  
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const productHandles = cart.items.map(item => item.handle);
      const foundCollections = new Set();

      const checks = [];

      allCollections.forEach(collectionHandle => {
        productHandles.forEach(productHandle => {
          const url = `/collections/${collectionHandle}/products.json?limit=250`;

          const check = fetch(url)
            .then(res => res.json())
            .then(data => {
              if (!data.products) return;

              // Check if this collection contains the product
              const exists = data.products.some(
                p => p.handle === productHandle
              );
              if (exists) {
                foundCollections.add(collectionHandle);
              }
            });

          checks.push(check);
        });
      });

      Promise.all(checks).then(() => {
        foundCollections.forEach(handle => {
          document.body.classList.add(`collection-${handle}`);
        });
      });

    });

});